// // // import React, { useState } from "react";
// // // import { 
// // //   Box, Typography, Paper, Table, TableBody, TableCell, 
// // //   TableContainer, TableHead, TableRow, TextField, Button, CircularProgress 
// // // } from "@mui/material";
// // // import SearchIcon from "@mui/icons-material/Search";
// // // import axiosClient from "../axiosClient";
// // // import dayjs from "dayjs";
// // // import { useTranslation } from "react-i18next";

// // // const SmsEmailReports = () => {
// // //     const { t } = useTranslation();
// // //     const [loading, setLoading] = useState(false);
// // //     const [reports, setReports] = useState([]);
// // //     const [selectedMonth, setSelectedMonth] = useState(dayjs().format("YYYY-MM"));

// // //     const fetchSmsReports = async () => {
// // //         setLoading(true);
// // //         const start = dayjs(selectedMonth).startOf('month').format("YYYY-MM-DD");
// // //         const end = dayjs(selectedMonth).endOf('month').format("YYYY-MM-DD");
        
// // //         try {
// // //             // This calls your backend log
// // //             const response = await axiosClient.get("/api/sms-email-log/", { 
// // //                 params: { start, end } 
// // //             });
// // //             setReports(response.data);
// // //         } catch (error) {
// // //             console.error("Error fetching SMS reports:", error);
// // //             setReports([]);
// // //         } finally {
// // //             setLoading(false);
// // //         }
// // //     };

// // //     return (
// // //         <Box sx={{ p: 3 }}>
// // //             <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', color: 'primary.main' }}>
// // //                 {t("SMS/EMAIL SENT REPORTS CONSOLE")}
// // //             </Typography>

// // //             <Paper sx={{ p: 3, mb: 3, display: 'flex', gap: 2, alignItems: 'center', bgcolor: 'background.paper' }}>
// // //                 <TextField 
// // //                     label={t("Select Month")}
// // //                     type="month" 
// // //                     value={selectedMonth}
// // //                     onChange={(e) => setSelectedMonth(e.target.value)}
// // //                     InputLabelProps={{ shrink: true }}
// // //                     sx={{ width: 250 }}
// // //                 />
// // //                 <Button 
// // //                     variant="contained" 
// // //                     startIcon={<SearchIcon />} 
// // //                     onClick={fetchSmsReports}
// // //                     disabled={loading}
// // //                 >
// // //                     {t("PRESENT DATA")}
// // //                 </Button>
// // //             </Paper>

// // //             <TableContainer component={Paper} sx={{ maxHeight: 600, boxShadow: 3 }}>
// // //                 <Table stickyHeader>
// // //                     <TableHead>
// // //                         <TableRow>
// // //                             <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.dark', color: 'white' }}>{t("Time Sent")}</TableCell>
// // //                             <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.dark', color: 'white' }}>{t("Name")}</TableCell>
// // //                             <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.dark', color: 'white' }}>{t("Surname")}</TableCell>
// // //                             <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.dark', color: 'white' }}>{t("Role")}</TableCell>
// // //                             <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.dark', color: 'white' }}>{t("Message Text")}</TableCell>
// // //                         </TableRow>
// // //                     </TableHead>
// // //                     <TableBody>
// // //                         {loading ? (
// // //                             <TableRow>
// // //                                 <TableCell colSpan={5} align="center" sx={{ py: 5 }}>
// // //                                     <CircularProgress />
// // //                                 </TableCell>
// // //                             </TableRow>
// // //                         ) : reports.length > 0 ? (
// // //                             reports.map((row, index) => (
// // //                                 <TableRow key={index} hover>
// // //                                     <TableCell>{dayjs(row.sent_at).format("DD/MM/YYYY HH:mm")}</TableCell>
// // //                                     <TableCell>{row.first_name}</TableCell>
// // //                                     <TableCell>{row.last_name}</TableCell>
// // //                                     <TableCell>{row.role}</TableCell>
// // //                                     <TableCell sx={{ maxWidth: 500, wordWrap: 'break-word' }}>
// // //                                         {row.message_body}
// // //                                     </TableCell>
// // //                                 </TableRow>
// // //                             ))
// // //                         ) : (
// // //                             <TableRow>
// // //                                 <TableCell colSpan={5} align="center" sx={{ py: 10 }}>
// // //                                     <Typography color="textSecondary">
// // //                                         {t("No reports found. Click PRESENT DATA to load.")}
// // //                                     </Typography>
// // //                                 </TableCell>
// // //                             </TableRow>
// // //                         )}
// // //                     </TableBody>
// // //                 </Table>
// // //             </TableContainer>
// // //         </Box>
// // //     );
// // // };

// // // export default SmsEmailReports;


// // /////////////////////////////////////////////////////////

// // // import React, { useState } from "react";
// // // import { 
// // //     Box, Typography, Paper, Table, TableBody, TableCell, 
// // //     TableContainer, TableHead, TableRow, TextField, Button, CircularProgress 
// // // } from "@mui/material";
// // // import SearchIcon from "@mui/icons-material/Search";
// // // import FileDownloadIcon from "@mui/icons-material/FileDownload"; // ✅ Ensure this is imported
// // // import axiosClient from "../axiosClient";
// // // import dayjs from "dayjs";
// // // import { useTranslation } from "react-i18next";

// // // const SmsEmailReports = () => {
// // //     const { t } = useTranslation();
// // //     const [loading, setLoading] = useState(false);
// // //     const [reports, setReports] = useState([]);
// // //     const [selectedMonth, setSelectedMonth] = useState(dayjs().format("YYYY-MM"));

// // //     // ✅ FETCH DATA FOR THE TABLE
// // //     const fetchSmsReports = async () => {
// // //         setLoading(true);
// // //         const start = dayjs(selectedMonth).startOf('month').format("YYYY-MM-DD");
// // //         const end = dayjs(selectedMonth).endOf('month').format("YYYY-MM-DD");
        
// // //         try {
// // //             const response = await axiosClient.get("/api/sms-email-log/", { 
// // //                 params: { start, end } 
// // //             });
// // //             setReports(response.data);
// // //         } catch (error) {
// // //             console.error("Error fetching SMS reports:", error);
// // //             setReports([]);
// // //         } finally {
// // //             setLoading(false);
// // //         }
// // //     };

// // //     // ✅ DOWNLOAD EXCEL REPORT LOGIC
// // //     const downloadExcel = async () => {
// // //         const start = dayjs(selectedMonth).startOf('month').format("YYYY-MM-DD");
// // //         const end = dayjs(selectedMonth).endOf('month').format("YYYY-MM-DD");
        
// // //         try {
// // //             const response = await axiosClient.get("/api/sms-email-report-excel/", {
// // //                 params: { start, end },
// // //                 responseType: 'blob', // 👈 REQUIRED for binary files
// // //             });
            
// // //             const url = window.URL.createObjectURL(new Blob([response.data]));
// // //             const link = document.createElement('a');
// // //             link.href = url;
// // //             link.setAttribute('download', `SMS_Email_Report_${selectedMonth}.xlsx`);
// // //             document.body.appendChild(link);
// // //             link.click();
// // //             link.remove();
// // //         } catch (error) {
// // //             console.error("Export failed", error);
// // //             alert("Failed to download report. Check if the backend is running.");
// // //         }
// // //     };

// // //     return (
// // //         <Box sx={{ p: 3 }}>
// // //             <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', color: 'primary.main' }}>
// // //                 {t("SMS/EMAIL SENT REPORTS CONSOLE")}
// // //             </Typography>

// // //             <Paper sx={{ p: 3, mb: 3, display: 'flex', gap: 2, alignItems: 'center', bgcolor: 'background.paper' }}>
// // //                 <TextField 
// // //                     label={t("Select Month")}
// // //                     type="month" 
// // //                     value={selectedMonth}
// // //                     onChange={(e) => setSelectedMonth(e.target.value)}
// // //                     InputLabelProps={{ shrink: true }}
// // //                     sx={{ width: 250 }}
// // //                 />
// // //                 <Button 
// // //                     variant="contained" 
// // //                     startIcon={<SearchIcon />} 
// // //                     onClick={fetchSmsReports}
// // //                     disabled={loading}
// // //                 >
// // //                     {t("PRESENT DATA")}
// // //                 </Button>

// // //                 {/* ✅ DOWNLOAD BUTTON */}
// // //                 <Button 
// // //                     variant="contained" 
// // //                     color="success"
// // //                     startIcon={<FileDownloadIcon />} 
// // //                     onClick={downloadExcel}
// // //                     disabled={loading}
// // //                 >
// // //                     {t("DOWNLOAD EXCEL")}
// // //                 </Button>
// // //             </Paper>

// // //             <TableContainer component={Paper} sx={{ maxHeight: 600, boxShadow: 3 }}>
// // //                 <Table stickyHeader>
// // //                     <TableHead>
// // //                         <TableRow>
// // //                             <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.dark', color: 'white' }}>{t("Time Sent")}</TableCell>
// // //                             <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.dark', color: 'white' }}>{t("Name")}</TableCell>
// // //                             <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.dark', color: 'white' }}>{t("Surname")}</TableCell>
// // //                             <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.dark', color: 'white' }}>{t("Role")}</TableCell>
// // //                             <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.dark', color: 'white' }}>{t("Message Text")}</TableCell>
// // //                         </TableRow>
// // //                     </TableHead>
// // //                     <TableBody>
// // //                         {loading ? (
// // //                             <TableRow>
// // //                                 <TableCell colSpan={5} align="center" sx={{ py: 5 }}>
// // //                                     <CircularProgress />
// // //                                 </TableCell>
// // //                             </TableRow>
// // //                         ) : reports.length > 0 ? (
// // //                             reports.map((row, index) => (
// // //                                 <TableRow key={index} hover>
// // //                                     <TableCell>{dayjs(row.sent_at).format("DD/MM/YYYY HH:mm")}</TableCell>
// // //                                     <TableCell>{row.first_name}</TableCell>
// // //                                     <TableCell>{row.last_name}</TableCell>
// // //                                     <TableCell>{row.role}</TableCell>
// // //                                     <TableCell sx={{ maxWidth: 500, wordWrap: 'break-word' }}>
// // //                                         {row.message_body}
// // //                                     </TableCell>
// // //                                 </TableRow>
// // //                             ))
// // //                         ) : (
// // //                             <TableRow>
// // //                                 <TableCell colSpan={5} align="center" sx={{ py: 10 }}>
// // //                                     <Typography color="textSecondary">
// // //                                         {t("No reports found. Click PRESENT DATA to load.")}
// // //                                     </Typography>
// // //                                 </TableCell>
// // //                             </TableRow>
// // //                         )}
// // //                     </TableBody>
// // //                 </Table>
// // //             </TableContainer>
// // //         </Box>
// // //     );
// // // };

// // // export default SmsEmailReports;

// // //////////////////////////////////////////////////////

// // // import React, { useState } from "react";
// // // import { 
// // //     Box, Typography, Paper, Table, TableBody, TableCell, 
// // //     TableContainer, TableHead, TableRow, TextField, Button, CircularProgress, Stack 
// // // } from "@mui/material";
// // // import SearchIcon from "@mui/icons-material/Search";
// // // import FileDownloadIcon from "@mui/icons-material/FileDownload";
// // // import axiosClient from "../axiosClient";
// // // import dayjs from "dayjs";
// // // import { useTranslation } from "react-i18next";

// // // const SmsEmailReports = () => {
// // //     const { t } = useTranslation();
// // //     const [loading, setLoading] = useState(false);
// // //     const [reports, setReports] = useState([]);
// // //     const [selectedMonth, setSelectedMonth] = useState(dayjs().format("YYYY-MM"));
// // //     const [activeType, setActiveType] = useState("sms"); // Tracks current view: 'sms' or 'email'

// // //     // ✅ FETCH DATA: Updated to accept 'type' (sms/email)
// // //     const fetchReports = async (type) => {
// // //         setLoading(true);
// // //         setActiveType(type);
// // //         const start = dayjs(selectedMonth).startOf('month').format("YYYY-MM-DD");
// // //         const end = dayjs(selectedMonth).endOf('month').format("YYYY-MM-DD");
        
// // //         try {
// // //             const response = await axiosClient.get("/api/sms-email-log/", { 
// // //                 params: { start, end, type: type } 
// // //             });
// // //             setReports(response.data);
// // //         } catch (error) {
// // //             console.error(`Error fetching ${type} reports:`, error);
// // //             setReports([]);
// // //         } finally {
// // //             setLoading(false);
// // //         }
// // //     };

// // //     // ✅ DOWNLOAD EXCEL: Updated to accept 'type' (sms/email)
// // //     const downloadExcel = async (type) => {
// // //         const start = dayjs(selectedMonth).startOf('month').format("YYYY-MM-DD");
// // //         const end = dayjs(selectedMonth).endOf('month').format("YYYY-MM-DD");
        
// // //         try {
// // //             const response = await axiosClient.get("/api/sms-email-report-excel/", {
// // //                 params: { start, end, type: type },
// // //                 responseType: 'blob', 
// // //             });
            
// // //             const url = window.URL.createObjectURL(new Blob([response.data]));
// // //             const link = document.createElement('a');
// // //             link.href = url;
// // //             link.setAttribute('download', `${type.toUpperCase()}_Report_${selectedMonth}.xlsx`);
// // //             document.body.appendChild(link);
// // //             link.click();
// // //             link.remove();
// // //         } catch (error) {
// // //             console.error("Export failed", error);
// // //             alert(`Failed to download ${type.toUpperCase()} report.`);
// // //         }
// // //     };

// // //     return (
// // //         <Box sx={{ p: 3 }}>
// // //             <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', color: 'primary.main' }}>
// // //                 {t("SMS/EMAIL SENT REPORTS CONSOLE")}
// // //             </Typography>

// // //             <Paper sx={{ p: 3, mb: 3, bgcolor: 'background.paper' }}>
// // //                 <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap">
// // //                     {/* Month Picker */}
// // //                     <TextField 
// // //                         label={t("Select Month")}
// // //                         type="month" 
// // //                         value={selectedMonth}
// // //                         onChange={(e) => setSelectedMonth(e.target.value)}
// // //                         InputLabelProps={{ shrink: true }}
// // //                         sx={{ width: 200 }}
// // //                     />

// // //                     {/* View SMS Button */}
// // //                     <Button 
// // //                         variant={activeType === "sms" ? "contained" : "outlined"} 
// // //                         startIcon={<SearchIcon />} 
// // //                         onClick={() => fetchReports("sms")}
// // //                         disabled={loading}
// // //                     >
// // //                         {t("PRESENT SMS DATA")}
// // //                     </Button>

// // //                     {/* View Email Button */}
// // //                     <Button 
// // //                         variant={activeType === "email" ? "contained" : "outlined"} 
// // //                         color="info"
// // //                         startIcon={<SearchIcon />} 
// // //                         onClick={() => fetchReports("email")}
// // //                         disabled={loading}
// // //                     >
// // //                         {t("PRESENT EMAIL DATA")}
// // //                     </Button>

// // //                     {/* Download SMS Button */}
// // //                     <Button 
// // //                         variant="contained" 
// // //                         color="success"
// // //                         startIcon={<FileDownloadIcon />} 
// // //                         onClick={() => downloadExcel("sms")}
// // //                         disabled={loading}
// // //                     >
// // //                         {t("DOWNLOAD SMS EXCEL")}
// // //                     </Button>

// // //                     {/* Download Email Button */}
// // //                     <Button 
// // //                         variant="contained" 
// // //                         color="warning"
// // //                         startIcon={<FileDownloadIcon />} 
// // //                         onClick={() => downloadExcel("email")}
// // //                         disabled={loading}
// // //                     >
// // //                         {t("DOWNLOAD EMAIL EXCEL")}
// // //                     </Button>
// // //                 </Stack>
// // //             </Paper>

// // //             {/* --- DATA TABLE --- */}
// // //             <TableContainer component={Paper} sx={{ maxHeight: 600, boxShadow: 3 }}>
// // //                 <Table stickyHeader>
// // //                     <TableHead>
// // //                         <TableRow>
// // //                             <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.dark', color: 'white' }}>{t("Time Sent")}</TableCell>
// // //                             <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.dark', color: 'white' }}>{t("Name")}</TableCell>
// // //                             <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.dark', color: 'white' }}>{t("Surname")}</TableCell>
// // //                             <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.dark', color: 'white' }}>{t("Role")}</TableCell>
// // //                             <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.dark', color: 'white' }}>{t("Message Text")}</TableCell>
// // //                         </TableRow>
// // //                     </TableHead>
// // //                     <TableBody>
// // //                         {loading ? (
// // //                             <TableRow>
// // //                                 <TableCell colSpan={5} align="center" sx={{ py: 5 }}>
// // //                                     <CircularProgress />
// // //                                 </TableCell>
// // //                             </TableRow>
// // //                         ) : reports.length > 0 ? (
// // //                             reports.map((row, index) => (
// // //                                 <TableRow key={index} hover>
// // //                                     <TableCell>{dayjs(row.sent_at).format("DD/MM/YYYY HH:mm")}</TableCell>
// // //                                     <TableCell>{row.first_name}</TableCell>
// // //                                     <TableCell>{row.last_name}</TableCell>
// // //                                     <TableCell>{row.role}</TableCell>
// // //                                     <TableCell sx={{ maxWidth: 500, wordWrap: 'break-word' }}>
// // //                                         {row.message_body}
// // //                                     </TableCell>
// // //                                 </TableRow>
// // //                             ))
// // //                         ) : (
// // //                             <TableRow>
// // //                                 <TableCell colSpan={5} align="center" sx={{ py: 10 }}>
// // //                                     <Typography color="textSecondary">
// // //                                         {t("No reports found. Click a PRESENT button to load.")}
// // //                                     </Typography>
// // //                                 </TableCell>
// // //                             </TableRow>
// // //                         )}
// // //                     </TableBody>
// // //                 </Table>
// // //             </TableContainer>
// // //         </Box>
// // //     );
// // // };

// // // export default SmsEmailReports;



// // // import React, { useState } from "react";
// // // import { 
// // //     Box, Typography, Paper, Table, TableBody, TableCell, 
// // //     TableContainer, TableHead, TableRow, TextField, Button, CircularProgress, Stack 
// // // } from "@mui/material";
// // // import SearchIcon from "@mui/icons-material/Search";
// // // import FileDownloadIcon from "@mui/icons-material/FileDownload";
// // // import axiosClient from "../axiosClient";
// // // import dayjs from "dayjs";
// // // import { useTranslation } from "react-i18next";

// // // const SmsEmailReports = () => {
// // //     const { t } = useTranslation();
// // //     const [loading, setLoading] = useState(false);
// // //     const [reports, setReports] = useState([]);
// // //     const [selectedMonth, setSelectedMonth] = useState(dayjs().format("YYYY-MM"));
// // //     const [activeView, setActiveView] = useState("sms"); // Track if we are looking at SMS or Email

// // //     // ✅ FETCH DATA: Now passes the 'type' to the backend
// // //     const fetchReports = async (type) => {
// // //         setLoading(true);
// // //         setActiveView(type);
// // //         const start = dayjs(selectedMonth).startOf('month').format("YYYY-MM-DD");
// // //         const end = dayjs(selectedMonth).endOf('month').format("YYYY-MM-DD");
        
// // //         try {
// // //             const response = await axiosClient.get("/api/sms-email-log/", { 
// // //                 params: { start, end, type: type } 
// // //             });
// // //             setReports(response.data);
// // //         } catch (error) {
// // //             console.error("Fetch Error:", error);
// // //             setReports([]);
// // //         } finally {
// // //             setLoading(false);
// // //         }
// // //     };

// // //     // ✅ DOWNLOAD EXCEL: Now passes the 'type' to get the correct file
// // //     const downloadExcel = async (type) => {
// // //         const start = dayjs(selectedMonth).startOf('month').format("YYYY-MM-DD");
// // //         const end = dayjs(selectedMonth).endOf('month').format("YYYY-MM-DD");
        
// // //         try {
// // //             const response = await axiosClient.get("/api/sms-email-report-excel/", {
// // //                 params: { start, end, type: type },
// // //                 responseType: 'blob', 
// // //             });
            
// // //             const url = window.URL.createObjectURL(new Blob([response.data]));
// // //             const link = document.createElement('a');
// // //             link.href = url;
// // //             link.setAttribute('download', `${type.toUpperCase()}_Report_${selectedMonth}.xlsx`);
// // //             document.body.appendChild(link);
// // //             link.click();
// // //             link.remove();
// // //         } catch (error) {
// // //             console.error("Download Error:", error);
// // //             alert(t("Failed to download report"));
// // //         }
// // //     };

// // //     return (
// // //         <Box sx={{ p: 3 }}>
// // //             <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', color: 'primary.main', textAlign: 'center' }}>
// // //                 {t("SMS/EMAIL SENT REPORTS CONSOLE")}
// // //             </Typography>

// // //             {/* --- BUTTON BAR --- */}
// // //             <Paper sx={{ p: 3, mb: 3, bgcolor: 'background.paper' }}>
// // //                 <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" flexWrap="wrap">
// // //                     {/* Month Picker */}
// // //                     <TextField 
// // //                         label={t("Select Month")}
// // //                         type="month" 
// // //                         value={selectedMonth}
// // //                         onChange={(e) => setSelectedMonth(e.target.value)}
// // //                         InputLabelProps={{ shrink: true }}
// // //                         sx={{ width: 180 }}
// // //                     />

// // //                     {/* Present Data Buttons */}
// // //                     <Button 
// // //                         variant={activeView === "sms" ? "contained" : "outlined"} 
// // //                         startIcon={<SearchIcon />} 
// // //                         onClick={() => fetchReports("sms")}
// // //                         disabled={loading}
// // //                     >
// // //                         {t("PRESENT SMS DATA")}
// // //                     </Button>

// // //                     <Button 
// // //                         variant={activeView === "email" ? "contained" : "outlined"} 
// // //                         color="info"
// // //                         startIcon={<SearchIcon />} 
// // //                         onClick={() => fetchReports("email")}
// // //                         disabled={loading}
// // //                     >
// // //                         {t("PRESENT EMAIL DATA")}
// // //                     </Button>

// // //                     {/* Download Buttons */}
// // //                     <Button 
// // //                         variant="contained" 
// // //                         color="success"
// // //                         startIcon={<FileDownloadIcon />} 
// // //                         onClick={() => downloadExcel("sms")}
// // //                         disabled={loading}
// // //                     >
// // //                         {t("DOWNLOAD SMS REPORT")}
// // //                     </Button>

// // //                     <Button 
// // //                         variant="contained" 
// // //                         color="warning"
// // //                         startIcon={<FileDownloadIcon />} 
// // //                         onClick={() => downloadExcel("email")}
// // //                         disabled={loading}
// // //                     >
// // //                         {t("DOWNLOAD EMAIL REPORT")}
// // //                     </Button>
// // //                 </Stack>
// // //             </Paper>

// // //             {/* --- TABLE SECTION --- */}
// // //             <TableContainer component={Paper} sx={{ maxHeight: 600, boxShadow: 3 }}>
// // //                 <Table stickyHeader>
// // //                     <TableHead>
// // //                         <TableRow>
// // //                             <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.dark', color: 'white' }}>{t("Time Sent")}</TableCell>
// // //                             <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.dark', color: 'white' }}>{t("Name")}</TableCell>
// // //                             <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.dark', color: 'white' }}>{t("Surname")}</TableCell>
// // //                             <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.dark', color: 'white' }}>{t("Role")}</TableCell>
// // //                             <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.dark', color: 'white' }}>{t("Message Text")}</TableCell>
// // //                         </TableRow>
// // //                     </TableHead>
// // //                      <TableBody>
// // //                         {loading ? (
// // //                             <TableRow><TableCell colSpan={5} align="center" sx={{ py: 5 }}><CircularProgress /></TableCell></TableRow>
// // //                         ) : reports.length > 0 ? (
// // //                             reports.map((row, index) => (
// // //                                 <TableRow key={index} hover>
// // //                                     {/* Backend format is YYYY-MM-DDTHH:MM:SS, converted here to readable format */}
// // //                                     <TableCell>{dayjs(row.sent_at).format("DD/MM/YYYY HH:mm")}</TableCell>
// // //                                     <TableCell>{row.first_name}</TableCell>
// // //                                     <TableCell>{row.last_name}</TableCell>
// // //                                     <TableCell>{row.role}</TableCell>
// // //                                     <TableCell sx={{ maxWidth: 500, wordWrap: 'break-word' }}>
// // //                                         {row.message_body}
// // //                                     </TableCell>
// // //                                 </TableRow>
// // //                             )) }
// // //                         ) : (
// // //                             <TableRow>
// // //                                 <TableCell colSpan={5} align="center" sx={{ py: 10 }}>
// // //                                     <Typography color="textSecondary">
// // //                                         {t("No data found for this selection. Click a PRESENT button to load.")}
// // //                                     </Typography>
// // //                                 </TableCell>
// // //                             </TableRow>
// // //                         )}
// // //                     </TableBody>
// // //                 </Table>
// // //             </TableContainer>
// // //         </Box>
// // //     );
// // // };

// // // export default SmsEmailReports;


// // // import React, { useState, useEffect } from "react";
// // // import {
// // //   Box, Typography, Card, CardContent, Table, TableHead, 
// // //   TableRow, TableCell, TableBody, TableContainer, Paper, 
// // //   Button, Stack, TextField, Chip, CircularProgress
// // // } from "@mui/material";
// // // import SearchIcon from "@mui/icons-material/Search";
// // // import FileDownloadIcon from "@mui/icons-material/FileDownload";
// // // import axiosClient from "../axiosClient";
// // // import dayjs from "dayjs";

// // // const SmsEmailReportScreen = () => {
// // //   const [reports, setReports] = useState([]);
// // //   const [loading, setLoading] = useState(false);
// // //   const [selectedMonth, setSelectedMonth] = useState(dayjs().format("YYYY-MM"));

// // //   // Fetch Data Function
// // //   const fetchReports = async (type) => {
// // //     setLoading(true);
// // //     // Calculate start and end of month for the API filter
// // //     const start = dayjs(selectedMonth).startOf('month').format('YYYY-MM-DD');
// // //     const end = dayjs(selectedMonth).endOf('month').format('YYYY-MM-DD');
    
// // //     try {
// // //       const response = await axiosClient.get(`api/sms-email-logs/`, {
// // //         params: { start, end, type }
// // //       });
// // //       setReports(response.data);
// // //     } catch (err) {
// // //       console.error("Error fetching reports:", err);
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };

// // //   const downloadExcel = (type) => {
// // //     const start = dayjs(selectedMonth).startOf('month').format('YYYY-MM-DD');
// // //     const end = dayjs(selectedMonth).endOf('month').format('YYYY-MM-DD');
// // //     window.open(`${import.meta.env.VITE_API_BASE_URL}/api/export-sms-email-logs/?start=${start}&end=${end}&type=${type}`, '_blank');
// // //   };

// // //   return (
// // //     <Box sx={{ p: 3 }}>
// // //       <Typography variant="h5" color="#90caf9" sx={{ mb: 4, textAlign: 'center', fontWeight: 'bold' }}>
// // //         SMS/EMAIL SENT REPORTS CONSOLE
// // //       </Typography>

// // //       <Card sx={{ bgcolor: '#1e1e1e', mb: 4, p: 2 }}>
// // //         <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" flexWrap="wrap">
// // //           <TextField
// // //             label="Select Month"
// // //             type="month"
// // //             value={selectedMonth}
// // //             onChange={(e) => setSelectedMonth(e.target.value)}
// // //             sx={{ 
// // //               bgcolor: '#2c2c2c', 
// // //               input: { color: 'white' }, 
// // //               label: { color: '#aaa' },
// // //               borderRadius: 1
// // //             }}
// // //             InputLabelProps={{ shrink: true }}
// // //           />
          
// // //           <Button variant="outlined" startIcon={<SearchIcon />} onClick={() => fetchReports('sms')}>
// // //             Present SMS Data
// // //           </Button>
          
// // //           <Button variant="outlined" startIcon={<SearchIcon />} onClick={() => fetchReports('email')}>
// // //             Present Email Data
// // //           </Button>

// // //           <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} onClick={() => downloadExcel('sms')}>
// // //             Download SMS Report
// // //           </Button>

// // //           <Button variant="contained" color="warning" startIcon={<FileDownloadIcon />} onClick={() => downloadExcel('email')}>
// // //             Download Email Report
// // //           </Button>
// // //         </Stack>
// // //       </Card>

// // //       <TableContainer component={Paper} sx={{ bgcolor: '#1e1e1e', maxHeight: '600px' }}>
// // //         <Table stickyHeader size="small">
// // //           <TableHead>
// // //             <TableRow>
// // //               <TableCell sx={{ bgcolor: '#5c85a6', color: '#fff', fontWeight: 'bold' }}>Time Sent</TableCell>
// // //               <TableCell sx={{ bgcolor: '#5c85a6', color: '#fff', fontWeight: 'bold' }}>NAME</TableCell>
// // //               <TableCell sx={{ bgcolor: '#5c85a6', color: '#fff', fontWeight: 'bold' }}>SURNAME</TableCell>
// // //               <TableCell sx={{ bgcolor: '#5c85a6', color: '#fff', fontWeight: 'bold' }}>ROLE</TableCell>
// // //               <TableCell sx={{ bgcolor: '#5c85a6', color: '#fff', fontWeight: 'bold' }}>Message Text</TableCell>
// // //             </TableRow>
// // //           </TableHead>
// // //           <TableBody>
// // //             {loading ? (
// // //               <TableRow>
// // //                 <TableCell colSpan={5} align="center" sx={{ py: 5 }}>
// // //                   <CircularProgress />
// // //                 </TableCell>
// // //               </TableRow>
// // //             ) : reports.length === 0 ? (
// // //               <TableRow>
// // //                 <TableCell colSpan={5} align="center" sx={{ py: 5, color: '#aaa' }}>
// // //                   No data found for selected criteria.
// // //                 </TableCell>
// // //               </TableRow>
// // //             ) : (
// // //               reports.map((report, index) => (
// // //                 <TableRow key={index} sx={{ '& td': { borderBottom: '1px solid #333' } }}>
// // //                   <TableCell sx={{ color: '#fff' }}>{report.sent_at}</TableCell>
// // //                   <TableCell sx={{ color: '#fff' }}>{report.first_name}</TableCell>
// // //                   <TableCell sx={{ color: '#fff' }}>{report.last_name}</TableCell>
// // //                   <TableCell>
// // //                     <Chip 
// // //                       label={report.role} 
// // //                       size="small" 
// // //                       sx={{ bgcolor: '#333', color: '#90caf9', fontSize: '0.7rem', fontWeight: 'bold' }} 
// // //                     />
// // //                   </TableCell>
                  
// // //                   {/* ✅ THE BEAUTIFUL FORMATTED MESSAGE CELL */}
// // //                   <TableCell sx={{ color: '#fff', maxWidth: '500px', py: 1.5 }}>
// // //                     {report.message_text.includes('|') ? (
// // //                       report.message_text.split('|').map((part, i) => {
// // //                         const isRec = part.includes('Rec:');
// // //                         const isStaff = part.includes('Staff:');
// // //                         return (
// // //                           <Typography 
// // //                             key={i} 
// // //                             variant="body2" 
// // //                             sx={{ 
// // //                               color: isRec ? '#90caf9' : (isStaff ? '#4caf50' : '#fff'),
// // //                               fontStyle: (isRec || isStaff) ? 'italic' : 'normal',
// // //                               display: 'block',
// // //                               lineHeight: 1.4
// // //                             }}
// // //                           >
// // //                             {part.trim()}
// // //                           </Typography>
// // //                         );
// // //                       })
// // //                     ) : (
// // //                       <Typography variant="body2">{report.message_text}</Typography>
// // //                     )}
// // //                   </TableCell>
// // //                 </TableRow>
// // //               ))
// // //             )}
// // //           </TableBody>
// // //         </Table>
// // //       </TableContainer>
// // //     </Box>
// // //   );
// // // };

// // // export default SmsEmailReportScreen;




// // import React, { useState, useEffect } from "react";
// // import {
// //   Box, Typography, Card, CardContent, Table, TableHead, 
// //   TableRow, TableCell, TableBody, TableContainer, Paper, 
// //   Button, Stack, TextField, Chip, CircularProgress
// // } from "@mui/material";
// // import SearchIcon from "@mui/icons-material/Search";
// // import FileDownloadIcon from "@mui/icons-material/FileDownload";
// // import axiosClient from "../axiosClient";
// // import dayjs from "dayjs";

// // const SmsEmailReportScreen = () => {
// //   const [reports, setReports] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [selectedMonth, setSelectedMonth] = useState(dayjs().format("YYYY-MM"));

// //   const fetchReports = async (type) => {
// //     setLoading(true);
// //     const start = dayjs(selectedMonth).startOf('month').format('YYYY-MM-DD');
// //     const end = dayjs(selectedMonth).endOf('month').format('YYYY-MM-DD');
    
// //     try {
// //       // ✅ FIXED URL to match Backend
// //       const response = await axiosClient.get(`api/sms-email-logs/`, {
// //         params: { start, end, type }
// //       });
// //       setReports(response.data);
// //     } catch (err) {
// //       console.error("Error fetching reports:", err);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const downloadExcel = (type) => {
// //     const start = dayjs(selectedMonth).startOf('month').format('YYYY-MM-DD');
// //     const end = dayjs(selectedMonth).endOf('month').format('YYYY-MM-DD');
// //     // ✅ FIXED Download URL logic
// //     const baseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000';
// //     window.open(`${baseUrl}/api/export-sms-email-logs/?start=${start}&end=${end}&type=${type}`, '_blank');
// //   };

// //   return (
// //     <Box sx={{ p: 3 }}>
// //       <Typography variant="h5" color="#90caf9" sx={{ mb: 4, textAlign: 'center', fontWeight: 'bold' }}>
// //         SMS/EMAIL SENT REPORTS CONSOLE
// //       </Typography>

// //       <Card sx={{ bgcolor: '#1e1e1e', mb: 4, p: 2 }}>
// //         <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
// //           <TextField
// //             label="Select Month"
// //             type="month"
// //             value={selectedMonth}
// //             onChange={(e) => setSelectedMonth(e.target.value)}
// //             sx={{ bgcolor: '#2c2c2c', input: { color: 'white' }, borderRadius: 1 }}
// //             InputLabelProps={{ shrink: true }}
// //           />
// //           <Button variant="outlined" startIcon={<SearchIcon />} onClick={() => fetchReports('sms')}>SMS Data</Button>
// //           <Button variant="outlined" startIcon={<SearchIcon />} onClick={() => fetchReports('email')}>Email Data</Button>
// //           <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} onClick={() => downloadExcel('sms')}>Download SMS</Button>
// //           <Button variant="contained" color="warning" startIcon={<FileDownloadIcon />} onClick={() => downloadExcel('email')}>Download Email</Button>
// //         </Stack>
// //       </Card>

// //       <TableContainer component={Paper} sx={{ bgcolor: '#1e1e1e' }}>
// //         <Table size="small">
// //           <TableHead>
// //             <TableRow>
// //               <TableCell sx={{ bgcolor: '#5c85a6', color: '#fff' }}>Time Sent</TableCell>
// //               <TableCell sx={{ bgcolor: '#5c85a6', color: '#fff' }}>NAME</TableCell>
// //               <TableCell sx={{ bgcolor: '#5c85a6', color: '#fff' }}>SURNAME</TableCell>
// //               <TableCell sx={{ bgcolor: '#5c85a6', color: '#fff' }}>ROLE</TableCell>
// //               <TableCell sx={{ bgcolor: '#5c85a6', color: '#fff' }}>Message Text</TableCell>
// //             </TableRow>
// //           </TableHead>
// //           <TableBody>
// //             {loading ? (
// //               <TableRow><TableCell colSpan={5} align="center"><CircularProgress /></TableCell></TableRow>
// //             ) : (
// //               reports.map((report, index) => (
// //                 <TableRow key={index} sx={{ '& td': { borderBottom: '1px solid #333' } }}>
// //                   <TableCell sx={{ color: '#fff' }}>{report.sent_at}</TableCell>
                  
// //                   {/* ✅ ADDED BLUE FRAME FOR NAME */}
// //                   <TableCell>
// //                     <Chip label={report.first_name} size="small" variant="outlined" sx={{ color: '#90caf9', borderColor: '#90caf9' }} />
// //                   </TableCell>
                  
// //                   {/* ✅ ADDED BLUE FRAME FOR SURNAME */}
// //                   <TableCell>
// //                     <Chip label={report.last_name} size="small" variant="outlined" sx={{ color: '#90caf9', borderColor: '#90caf9' }} />
// //                   </TableCell>

// //                   <TableCell sx={{ color: '#aaa' }}>{report.role}</TableCell>
                  
// //                   <TableCell sx={{ color: '#fff', maxWidth: '500px' }}>
// //                     {report.message_text.split('|').map((part, i) => (
// //                       <Typography key={i} variant="caption" sx={{ 
// //                         display: 'block', 
// //                         color: part.includes('Rec:') ? '#90caf9' : (part.includes('Staff:') ? '#4caf50' : '#fff'),
// //                         fontStyle: i > 0 ? 'italic' : 'normal'
// //                       }}>
// //                         {part.trim()}
// //                       </Typography>
// //                     ))}
// //                   </TableCell>
// //                 </TableRow>
// //               ))
// //             )}
// //           </TableBody>
// //         </Table>
// //       </TableContainer>
// //     </Box>
// //   );
// // };

// // export default SmsEmailReportScreen;



// import React, { useState, useEffect } from "react";
// import {
//   Box, Typography, Card, Table, TableHead, 
//   TableRow, TableCell, TableBody, TableContainer, Paper, 
//   Button, Stack, TextField, Chip, CircularProgress
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import FileDownloadIcon from "@mui/icons-material/FileDownload";
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";

// const SmsEmailReportScreen = () => {
//   const [reports, setReports] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [selectedMonth, setSelectedMonth] = useState(dayjs().format("YYYY-MM"));

//   const fetchReports = async (type) => {
//     setLoading(true);
//     const start = dayjs(selectedMonth).startOf('month').format('YYYY-MM-DD');
//     const end = dayjs(selectedMonth).endOf('month').format('YYYY-MM-DD');
    
//     try {
//       // ✅ Calls the corrected Backend URL
//       const response = await axiosClient.get(`api/sms-email-logs/`, {
//         params: { start, end, type }
//       });
//       setReports(response.data);
//     } catch (err) {
//       console.error("Error fetching reports:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const downloadExcel = (type) => {
//     const start = dayjs(selectedMonth).startOf('month').format('YYYY-MM-DD');
//     const end = dayjs(selectedMonth).endOf('month').format('YYYY-MM-DD');
//     const baseUrl = import.meta.env.VITE_API_BASE_URL || window.location.origin;
//     window.open(`${baseUrl}/api/export-sms-email-logs/?start=${start}&end=${end}&type=${type}`, '_blank');
//   };

//   return (
//     <Box sx={{ p: 3 }}>
//       <Typography variant="h5" color="#90caf9" sx={{ mb: 4, textAlign: 'center', fontWeight: 'bold' }}>
//         SMS/EMAIL SENT REPORTS CONSOLE
//       </Typography>

//       <Card sx={{ bgcolor: '#1e1e1e', mb: 4, p: 2 }}>
//         <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
//           <TextField
//             label="Select Month"
//             type="month"
//             value={selectedMonth}
//             onChange={(e) => setSelectedMonth(e.target.value)}
//             sx={{ bgcolor: '#2c2c2c', input: { color: 'white' }, borderRadius: 1 }}
//             InputLabelProps={{ shrink: true }}
//           />
//           <Button variant="outlined" startIcon={<SearchIcon />} onClick={() => fetchReports('sms')}>
//             PRESENT SMS DATA
//           </Button>
//           <Button variant="outlined" startIcon={<SearchIcon />} onClick={() => fetchReports('email')}>
//             PRESENT EMAIL DATA
//           </Button>
//           <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} onClick={() => downloadExcel('sms')}>
//             DOWNLOAD SMS REPORT
//           </Button>
//           <Button variant="contained" color="warning" startIcon={<FileDownloadIcon />} onClick={() => downloadExcel('email')}>
//             DOWNLOAD EMAIL REPORT
//           </Button>
//         </Stack>
//       </Card>

//       <TableContainer component={Paper} sx={{ bgcolor: '#1e1e1e' }}>
//         <Table size="small">
//           <TableHead>
//             <TableRow>
//               <TableCell sx={{ bgcolor: '#5c85a6', color: '#fff', fontWeight: 'bold' }}>Time Sent</TableCell>
//               <TableCell sx={{ bgcolor: '#5c85a6', color: '#fff', fontWeight: 'bold' }}>NAME</TableCell>
//               <TableCell sx={{ bgcolor: '#5c85a6', color: '#fff', fontWeight: 'bold' }}>SURNAME</TableCell>
//               <TableCell sx={{ bgcolor: '#5c85a6', color: '#fff', fontWeight: 'bold' }}>ROLE</TableCell>
//               <TableCell sx={{ bgcolor: '#5c85a6', color: '#fff', fontWeight: 'bold' }}>Message Text</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {loading ? (
//               <TableRow><TableCell colSpan={5} align="center" sx={{ py: 3 }}><CircularProgress size={24} /></TableCell></TableRow>
//             ) : reports.length === 0 ? (
//               <TableRow><TableCell colSpan={5} align="center" sx={{ color: '#aaa', py: 4 }}>No reports found for this month.</TableCell></TableRow>
//             ) : (
//               reports.map((report, index) => (
//                 <TableRow key={index} sx={{ '& td': { borderBottom: '1px solid #333' } }}>
//                   <TableCell sx={{ color: '#fff' }}>{report.sent_at}</TableCell>
                  
//                   {/* ✅ BEAUTIFUL BLUE FRAME FOR NAME */}
//                   <TableCell>
//                     <Chip 
//                       label={report.first_name} 
//                       size="small" 
//                       variant="outlined" 
//                       sx={{ color: '#90caf9', borderColor: '#90caf9', fontWeight: 'bold' }} 
//                     />
//                   </TableCell>
                  
//                   {/* ✅ BEAUTIFUL BLUE FRAME FOR SURNAME */}
//                   <TableCell>
//                     <Chip 
//                       label={report.last_name} 
//                       size="small" 
//                       variant="outlined" 
//                       sx={{ color: '#90caf9', borderColor: '#90caf9', fontWeight: 'bold' }} 
//                     />
//                   </TableCell>

//                   <TableCell sx={{ color: '#aaa' }}>{report.role}</TableCell>
                  
//                   <TableCell sx={{ color: '#fff', maxWidth: '500px', py: 1 }}>
//                     {/* ✅ SPLITS BY '|' TO SHOW RECEPTION COMMENT BEAUTIFULLY */}
//                     {report.message_text.split('|').map((part, i) => (
//                       <Typography 
//                         key={i} 
//                         variant="caption" 
//                         sx={{ 
//                           display: 'block', 
//                           color: part.includes('Rec:') ? '#90caf9' : (part.includes('Staff:') ? '#4caf50' : '#fff'),
//                           fontStyle: i > 0 ? 'italic' : 'normal',
//                           lineHeight: 1.3,
//                           fontSize: '0.8rem'
//                         }}
//                       >
//                         {part.trim()}
//                       </Typography>
//                     ))}
//                   </TableCell>
//                 </TableRow>
//               ))
//             )}
//           </TableBody>
//         </Table>
//       </TableContainer>
//     </Box>
//   );
// };

// export default SmsEmailReportScreen;



////////////////////////////////////////////////////////////////////

// import React, { useState, useEffect } from "react";
// import {
//   Box, Typography, Card, Table, TableHead, 
//   TableRow, TableCell, TableBody, TableContainer, Paper, 
//   Button, Stack, TextField, Chip, CircularProgress
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import FileDownloadIcon from "@mui/icons-material/FileDownload";
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";

// const SmsEmailReportScreen = () => {
//   const [reports, setReports] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [selectedMonth, setSelectedMonth] = useState(dayjs().format("YYYY-MM"));

//   const fetchReports = async (type) => {
//     setLoading(true);
//     const start = dayjs(selectedMonth).startOf('month').format('YYYY-MM-DD');
//     const end = dayjs(selectedMonth).endOf('month').format('YYYY-MM-DD');
    
//     try {
//       const response = await axiosClient.get(`api/sms-email-logs/`, {
//         params: { start, end, type }
//       });
//       setReports(Array.isArray(response.data) ? response.data : []);
//     } catch (err) {
//       console.error("Fetch error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const downloadExcel = (type) => {
//     const start = dayjs(selectedMonth).startOf('month').format('YYYY-MM-DD');
//     const end = dayjs(selectedMonth).endOf('month').format('YYYY-MM-DD');
//     const baseUrl = import.meta.env.VITE_API_BASE_URL || window.location.origin;
//     window.open(`${baseUrl}/api/export-sms-email-logs/?start=${start}&end=${end}&type=${type}`, '_blank');
//   };

//   return (
//     <Box sx={{ p: 3 }}>
//       <Typography variant="h5" color="#fff" sx={{ mb: 4, textAlign: 'center', fontWeight: 'bold' }}>
//         SMS/EMAIL SENT REPORTS CONSOLE
//       </Typography>

//       <Card sx={{ bgcolor: '#1e1e1e', mb: 4, p: 2 }}>
//         <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
//           <TextField
//             label="Select Month"
//             type="month"
//             value={selectedMonth}
//             onChange={(e) => setSelectedMonth(e.target.value)}
//             sx={{ bgcolor: '#2c2c2c', input: { color: 'white' }, borderRadius: 1 }}
//             InputLabelProps={{ shrink: true }}
//           />
//           <Button variant="outlined" sx={{ color: '#fff', borderColor: '#444' }} startIcon={<SearchIcon />} onClick={() => fetchReports('sms')}>
//             PRESENT SMS DATA
//           </Button>
//           <Button variant="outlined" sx={{ color: '#fff', borderColor: '#444' }} startIcon={<SearchIcon />} onClick={() => fetchReports('email')}>
//             PRESENT EMAIL DATA
//           </Button>
//           <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} onClick={() => downloadExcel('sms')}>
//             DOWNLOAD SMS REPORT
//           </Button>
//           <Button variant="contained" color="warning" startIcon={<FileDownloadIcon />} onClick={() => downloadExcel('email')}>
//             DOWNLOAD EMAIL REPORT
//           </Button>
//         </Stack>
//       </Card>

//       <TableContainer component={Paper} sx={{ bgcolor: '#1e1e1e', borderRadius: 2 }}>
//         <Table size="small">
//           <TableHead>
//             <TableRow>
//               <TableCell sx={{ bgcolor: '#333', color: '#fff', fontWeight: 'bold' }}>Time Sent</TableCell>
//               <TableCell sx={{ bgcolor: '#333', color: '#fff', fontWeight: 'bold' }}>NAME</TableCell>
//               <TableCell sx={{ bgcolor: '#333', color: '#fff', fontWeight: 'bold' }}>SURNAME</TableCell>
//               <TableCell sx={{ bgcolor: '#333', color: '#fff', fontWeight: 'bold' }}>ROLE</TableCell>
//               <TableCell sx={{ bgcolor: '#333', color: '#fff', fontWeight: 'bold' }}>Message Text</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {loading ? (
//               <TableRow><TableCell colSpan={5} align="center" sx={{ py: 3 }}><CircularProgress size={24} /></TableCell></TableRow>
//             ) : reports.length === 0 ? (
//               <TableRow><TableCell colSpan={5} align="center" sx={{ color: '#aaa', py: 4 }}>No reports found.</TableCell></TableRow>
//             ) : (
//               reports.map((report, index) => (
//                 <TableRow key={index} sx={{ '& td': { borderBottom: '1px solid #333' } }}>
//                   <TableCell sx={{ color: '#fff' }}>{report.sent_at}</TableCell>
                  
//                   {/* ✅ REMOVED BLUE CHIPS - NOW CLEAN WHITE TEXT */}
//                   <TableCell sx={{ color: '#fff' }}>{report.first_name}</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>{report.last_name}</TableCell>

//                   <TableCell sx={{ color: '#aaa' }}>{report.role}</TableCell>
                  
//                   <TableCell sx={{ color: '#fff', maxWidth: '500px', py: 1 }}>
//                     {report.message_text.split('|').map((part, i) => (
//                       <Typography 
//                         key={i} 
//                         variant="caption" 
//                         sx={{ 
//                           display: 'block', 
//                           color: i === 0 ? '#fff' : '#bbb', // Primary text white, notes grey
//                           fontStyle: i > 0 ? 'italic' : 'normal',
//                           lineHeight: 1.3,
//                           fontSize: '0.85rem'
//                         }}
//                       >
//                         {part.trim()}
//                       </Typography>
//                     ))}
//                   </TableCell>
//                 </TableRow>
//               ))
//             )}
//           </TableBody>
//         </Table>
//       </TableContainer>
//     </Box>
//   );
// };

// export default SmsEmailReportScreen;


////////////////////////////////////////


// import React, { useState } from "react";
// import {
//   Box, Typography, Card, Table, TableHead, 
//   TableRow, TableCell, TableBody, TableContainer, Paper, 
//   Button, Stack, TextField, CircularProgress
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import FileDownloadIcon from "@mui/icons-material/FileDownload";
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";

// const SmsEmailReportScreen = () => {
//   const [reports, setReports] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [selectedMonth, setSelectedMonth] = useState(dayjs().format("YYYY-MM"));

//   const fetchReports = async (type) => {
//     setLoading(true);
//     const start = dayjs(selectedMonth).startOf('month').format('YYYY-MM-DD');
//     const end = dayjs(selectedMonth).endOf('month').format('YYYY-MM-DD');
    
//     try {
//       const response = await axiosClient.get('api/sms-email-logs/', {
//         params: { start, end, type }
//       });
//       setReports(Array.isArray(response.data) ? response.data : []);
//     } catch (err) {
//       console.error("Fetch error:", err);
//       setReports([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const downloadExcel = (type) => {
//     const start = dayjs(selectedMonth).startOf('month').format('YYYY-MM-DD');
//     const end = dayjs(selectedMonth).endOf('month').format('YYYY-MM-DD');
    
//     // ✅ FIX: Use window.location.origin to prevent "undefined" environment variable crash
//     const baseUrl = window.location.origin.includes('localhost') 
//       ? "http://161.97.119.130:8020" 
//       : window.location.origin;

//     const url = `${baseUrl}/api/export-sms-email-logs/?start=${start}&end=${end}&type=${type}`;
//     window.open(url, '_blank');
//   };

//   return (
//     <Box sx={{ p: 3 }}>
//       <Typography variant="h5" sx={{ mb: 4, textAlign: 'center', color: '#fff', fontWeight: 'bold' }}>
//         SMS/EMAIL SENT REPORTS CONSOLE
//       </Typography>

//       <Card sx={{ bgcolor: '#1e1e1e', mb: 4, p: 2 }}>
//         <Stack direction="row" spacing={2} justifyContent="center" alignItems="center">
//           <TextField
//             type="month"
//             value={selectedMonth}
//             onChange={(e) => setSelectedMonth(e.target.value)}
//             sx={{ bgcolor: '#fff', borderRadius: 1, width: '200px' }}
//           />
//           <Button variant="contained" startIcon={<SearchIcon />} onClick={() => fetchReports('sms')}>
//             PRESENT SMS DATA
//           </Button>
//           <Button variant="contained" startIcon={<SearchIcon />} onClick={() => fetchReports('email')}>
//             PRESENT EMAIL DATA
//           </Button>
//           <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} onClick={() => downloadExcel('sms')}>
//             DOWNLOAD SMS
//           </Button>
//           <Button variant="contained" color="warning" startIcon={<FileDownloadIcon />} onClick={() => downloadExcel('email')}>
//             DOWNLOAD EMAIL
//           </Button>
//         </Stack>
//       </Card>

//       <TableContainer component={Paper} sx={{ bgcolor: '#1e1e1e' }}>
//         <Table size="small">
//           <TableHead>
//             <TableRow sx={{ bgcolor: '#333' }}>
//               <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Time Sent</TableCell>
//               <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>NAME</TableCell>
//               <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>SURNAME</TableCell>
//               <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>ROLE</TableCell>
//               <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Message Text</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {loading ? (
//               <TableRow><TableCell colSpan={5} align="center" sx={{ py: 3 }}><CircularProgress size={24} /></TableCell></TableRow>
//             ) : reports.length === 0 ? (
//               <TableRow><TableCell colSpan={5} align="center" sx={{ color: '#aaa', py: 4 }}>No reports found.</TableCell></TableRow>
//             ) : (
//               reports.map((report, index) => (
//                 <TableRow key={index} sx={{ borderBottom: '1px solid #444' }}>
//                   <TableCell sx={{ color: '#fff' }}>{report.sent_at}</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>{report.first_name}</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>{report.last_name}</TableCell>
//                   <TableCell sx={{ color: '#ccc' }}>{report.role}</TableCell>
//                   <TableCell sx={{ color: '#fff', maxWidth: '500px', py: 1 }}>
//                     {(report.message_text || "").split('|').map((part, i) => (
//                       <div key={i} style={{ 
//                         display: 'block', 
//                         color: i === 0 ? '#fff' : '#bbb', 
//                         fontStyle: i > 0 ? 'italic' : 'normal',
//                         fontSize: '0.85rem'
//                       }}>
//                         {part.trim()}
//                       </div>
//                     ))}
//                   </TableCell>
//                 </TableRow>
//               ))
//             )}
//           </TableBody>
//         </Table>
//       </TableContainer>
//     </Box>
//   );
// };

// export default SmsEmailReportScreen;



///////////////////



// import React, { useState } from "react";
// import {
//   Box, Typography, Card, Table, TableHead, 
//   TableRow, TableCell, TableBody, TableContainer, Paper, 
//   Button, Stack, TextField, CircularProgress
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import FileDownloadIcon from "@mui/icons-material/FileDownload";
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";

// const SmsEmailReportScreen = () => {
//   const [reports, setReports] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [selectedMonth, setSelectedMonth] = useState(dayjs().format("YYYY-MM"));

//   const fetchReports = async (type) => {
//     setLoading(true);
//     const start = dayjs(selectedMonth).startOf('month').format('YYYY-MM-DD');
//     const end = dayjs(selectedMonth).endOf('month').format('YYYY-MM-DD');
    
//     try {
//       const response = await axiosClient.get('api/sms-email-logs/', {
//         params: { start, end, type }
//       });
//       setReports(Array.isArray(response.data) ? response.data : []);
//     } catch (err) {
//       console.error("Fetch error:", err);
//       setReports([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const downloadExcel = (type) => {
//     const start = dayjs(selectedMonth).startOf('month').format('YYYY-MM-DD');
//     const end = dayjs(selectedMonth).endOf('month').format('YYYY-MM-DD');
    
//     // ✅ Use a hardcoded fallback if your environment variables are not loading
//     const baseUrl = import.meta.env.VITE_API_BASE_URL || "http://161.97.119.130:8020";

//     // ✅ Match the plural name in your urls.py
//     const url = `${baseUrl}/api/export-sms-email-logs/?start=${start}&end=${end}&type=${type}`;
    
//     // ✅ THE FIX: Create a hidden 'a' tag to force a download instead of a route change
//     const link = document.createElement('a');
//     link.href = url;
//     link.setAttribute('target', '_blank'); // Open in new window
//     link.setAttribute('download', `Report_${type}.xlsx`); // Suggest filename
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   return (
//     <Box sx={{ p: 3 }}>
//       <Typography variant="h5" sx={{ mb: 4, textAlign: 'center', color: '#fff', fontWeight: 'bold' }}>
//         SMS/EMAIL SENT REPORTS CONSOLE
//       </Typography>

//       <Card sx={{ bgcolor: '#1e1e1e', mb: 4, p: 2 }}>
//         <Stack direction="row" spacing={2} justifyContent="center" alignItems="center">
//           <TextField
//             type="month"
//             value={selectedMonth}
//             onChange={(e) => setSelectedMonth(e.target.value)}
//             sx={{ bgcolor: '#fff', borderRadius: 1, width: '200px' }}
//           />
//           {/* type="button" prevents accidental form submission */}
//           <Button type="button" variant="contained" startIcon={<SearchIcon />} onClick={() => fetchReports('sms')}>
//             PRESENT SMS DATA
//           </Button>
//           <Button type="button" variant="contained" startIcon={<SearchIcon />} onClick={() => fetchReports('email')}>
//             PRESENT EMAIL DATA
//           </Button>
//           <Button type="button" variant="contained" color="success" startIcon={<FileDownloadIcon />} onClick={() => downloadExcel('sms')}>
//             DOWNLOAD SMS
//           </Button>
//           <Button type="button" variant="contained" color="warning" startIcon={<FileDownloadIcon />} onClick={() => downloadExcel('email')}>
//             DOWNLOAD EMAIL
//           </Button>
//         </Stack>
//       </Card>

//       <TableContainer component={Paper} sx={{ bgcolor: '#1e1e1e' }}>
//         <Table size="small">
//           <TableHead>
//             <TableRow sx={{ bgcolor: '#333' }}>
//               <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Time Sent</TableCell>
//               <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>NAME</TableCell>
//               <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>SURNAME</TableCell>
//               <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>ROLE</TableCell>
//               <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Message Text</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {loading ? (
//               <TableRow><TableCell colSpan={5} align="center" sx={{ py: 3 }}><CircularProgress size={24} /></TableCell></TableRow>
//             ) : reports.length === 0 ? (
//               <TableRow><TableCell colSpan={5} align="center" sx={{ color: '#aaa', py: 4 }}>No reports found.</TableCell></TableRow>
//             ) : (
//               reports.map((report, index) => (
//                 <TableRow key={index} sx={{ borderBottom: '1px solid #444' }}>
//                   <TableCell sx={{ color: '#fff' }}>{report.sent_at}</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>{report.first_name}</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>{report.last_name}</TableCell>
//                   <TableCell sx={{ color: '#ccc' }}>{report.role}</TableCell>
//                   <TableCell sx={{ color: '#fff', maxWidth: '500px', py: 1 }}>
//                     {(report.message_text || "").split('|').map((part, i) => (
//                       <div key={i} style={{ 
//                         display: 'block', 
//                         color: i === 0 ? '#fff' : '#bbb', 
//                         fontStyle: i > 0 ? 'italic' : 'normal',
//                         fontSize: '0.85rem'
//                       }}>
//                         {part.trim()}
//                       </div>
//                     ))}
//                   </TableCell>
//                 </TableRow>
//               ))
//             )}
//           </TableBody>
//         </Table>
//       </TableContainer>
//     </Box>
//   );
// };

// export default SmsEmailReportScreen;


// import React, { useState } from "react";
// import {
//   Box, Typography, Card, Table, TableHead, 
//   TableRow, TableCell, TableBody, TableContainer, Paper, 
//   Button, Stack, TextField, CircularProgress
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import FileDownloadIcon from "@mui/icons-material/FileDownload";
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";

// const SmsEmailReportScreen = () => {
//   const [reports, setReports] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [selectedMonth, setSelectedMonth] = useState(dayjs().format("YYYY-MM"));

//   const fetchReports = async (type) => {
//     setLoading(true);
//     const start = dayjs(selectedMonth).startOf('month').format('YYYY-MM-DD');
//     const end = dayjs(selectedMonth).endOf('month').format('YYYY-MM-DD');
    
//     try {
//       const response = await axiosClient.get('api/sms-email-logs/', {
//         params: { start, end, type }
//       });
//       setReports(Array.isArray(response.data) ? response.data : []);
//     } catch (err) {
//       console.error("Fetch error:", err);
//       setReports([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const downloadExcel = (type) => {
//     const start = dayjs(selectedMonth).startOf('month').format('YYYY-MM-DD');
//     const end = dayjs(selectedMonth).endOf('month').format('YYYY-MM-DD');
    
//     // ✅ Fix: Manual fallback for the URL so it never reads "undefined"
//     const baseUrl = "http://161.97.119.130:8020";
//     const url = `${baseUrl}/api/export-sms-email-logs/?start=${start}&end=${end}&type=${type}`;
    
//     // ✅ Fix: Use a hidden anchor to force download without navigating away
//     const link = document.createElement('a');
//     link.href = url;
//     link.target = '_blank';
//     link.download = `Report_${type}.xlsx`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   return (
//     <Box sx={{ p: 3 }}>
//       <Typography variant="h5" sx={{ mb: 4, textAlign: 'center', color: '#fff', fontWeight: 'bold' }}>
//         SMS/EMAIL SENT REPORTS CONSOLE
//       </Typography>

//       <Card sx={{ bgcolor: '#1e1e1e', mb: 4, p: 2 }}>
//         <Stack direction="row" spacing={2} justifyContent="center" alignItems="center">
//           <TextField
//             type="month"
//             value={selectedMonth}
//             onChange={(e) => setSelectedMonth(e.target.value)}
//             sx={{ bgcolor: '#fff', borderRadius: 1, width: '200px' }}
//           />
//           <Button variant="contained" startIcon={<SearchIcon />} onClick={() => fetchReports('sms')}>
//             PRESENT SMS DATA
//           </Button>
//           <Button variant="contained" startIcon={<SearchIcon />} onClick={() => fetchReports('email')}>
//             PRESENT EMAIL DATA
//           </Button>
//           <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} onClick={() => downloadExcel('sms')}>
//             DOWNLOAD SMS
//           </Button>
//           <Button variant="contained" color="warning" startIcon={<FileDownloadIcon />} onClick={() => downloadExcel('email')}>
//             DOWNLOAD EMAIL
//           </Button>
//         </Stack>
//       </Card>

//       <TableContainer component={Paper} sx={{ bgcolor: '#1e1e1e' }}>
//         <Table size="small">
//           <TableHead>
//             <TableRow sx={{ bgcolor: '#333' }}>
//               <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Time Sent</TableCell>
//               <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>NAME</TableCell>
//               <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>SURNAME</TableCell>
//               <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>ROLE</TableCell>
//               <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Message Text</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {loading ? (
//               <TableRow><TableCell colSpan={5} align="center" sx={{ py: 3 }}><CircularProgress size={24} /></TableCell></TableRow>
//             ) : reports.length === 0 ? (
//               <TableRow><TableCell colSpan={5} align="center" sx={{ color: '#aaa', py: 4 }}>No reports found.</TableCell></TableRow>
//             ) : (
//               reports.map((report, index) => (
//                 <TableRow key={index} sx={{ borderBottom: '1px solid #444' }}>
//                   <TableCell sx={{ color: '#fff' }}>{report.sent_at}</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>{report.first_name}</TableCell>
//                   <TableCell sx={{ color: '#fff' }}>{report.last_name}</TableCell>
//                   <TableCell sx={{ color: '#ccc' }}>{report.role}</TableCell>
//                   <TableCell sx={{ color: '#fff', maxWidth: '500px', py: 1 }}>
//                     {(report.message_text || "").split('|').map((part, i) => (
//                       <div key={i} style={{ 
//                         display: 'block', 
//                         // Style for NOTE: and Staff:
//                         color: i === 0 ? '#fff' : '#bbb', 
//                         fontStyle: i > 0 ? 'italic' : 'normal',
//                         fontSize: '0.85rem'
//                       }}>
//                         {part.trim()}
//                       </div>
//                     ))}
//                   </TableCell>
//                 </TableRow>
//               ))
//             )}
//           </TableBody>
//         </Table>
//       </TableContainer>
//     </Box>
//   );
// };

// export default SmsEmailReportScreen;





import React, { useState } from "react";
import {
  Box, Typography, Card, Table, TableHead, 
  TableRow, TableCell, TableBody, TableContainer, Paper, 
  Button, Stack, TextField, CircularProgress
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import axiosClient from "../axiosClient";
import dayjs from "dayjs";

const SmsEmailReportScreen = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(dayjs().format("YYYY-MM"));

  // 1. Fetch Data for the Table
  const fetchReports = async (type) => {
    setLoading(true);
    const start = dayjs(selectedMonth).startOf('month').format('YYYY-MM-DD');
    const end = dayjs(selectedMonth).endOf('month').format('YYYY-MM-DD');
    
    try {
      // const response = await axiosClient.get('api/sms-email-logs/', {
      const response = await axiosClient.get('sms-email-logs/', {
        params: { start, end, type }
      });
      setReports(Array.isArray(response.data) ? response.data : []);
    } catch (err) {
      console.error("Fetch error:", err);
      setReports([]);
    } finally {
      setLoading(false);
    }
  };

  // 2. Download Excel using Axios (This handles the Authentication Token)
  const downloadExcel = async (type) => {
    const start = dayjs(selectedMonth).startOf('month').format('YYYY-MM-DD');
    const end = dayjs(selectedMonth).endOf('month').format('YYYY-MM-DD');
    
    try {
      // Use axiosClient so the Authorization header is sent
      // const response = await axiosClient.get('api/export-sms-email-logs/', {
      const response = await axiosClient.get('export-sms-email-logs/', {
        params: { start, end, type },
        responseType: 'blob', // Important: Tells browser this is a file
      });

      // Create a URL for the file blob
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      
      // Forces the browser to download it
      link.setAttribute('download', `Report_${type}_${selectedMonth}.xlsx`);
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Excel download error:", err);
      alert("Error generating Excel. Please check console.");
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" sx={{ mb: 4, textAlign: 'center', color: '#fff', fontWeight: 'bold' }}>
        SMS/EMAIL SENT REPORTS CONSOLE
      </Typography>

      <Card sx={{ bgcolor: '#1e1e1e', mb: 4, p: 2 }}>
        <Stack direction="row" spacing={2} justifyContent="center" alignItems="center">
          <TextField
            type="month"
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(e.target.value)}
            sx={{ bgcolor: '#fff', borderRadius: 1, width: '200px' }}
          />
          <Button 
            variant="contained" 
            startIcon={<SearchIcon />} 
            onClick={() => fetchReports('sms')}
          >
            PRESENT SMS DATA
          </Button>
          <Button 
            variant="contained" 
            startIcon={<SearchIcon />} 
            onClick={() => fetchReports('email')}
          >
            PRESENT EMAIL DATA
          </Button>
          <Button 
            variant="contained" 
            color="success" 
            startIcon={<FileDownloadIcon />} 
            onClick={() => downloadExcel('sms')}
          >
            DOWNLOAD SMS
          </Button>
          <Button 
            variant="contained" 
            color="warning" 
            startIcon={<FileDownloadIcon />} 
            onClick={() => downloadExcel('email')}
          >
            DOWNLOAD EMAIL
          </Button>
        </Stack>
      </Card>

      <TableContainer component={Paper} sx={{ bgcolor: '#1e1e1e' }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: '#333' }}>
              <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Time Sent</TableCell>
              <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>NAME</TableCell>
              <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>SURNAME</TableCell>
              <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>ROLE</TableCell>
              <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Message Text</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={5} align="center" sx={{ py: 3 }}>
                  <CircularProgress size={24} />
                </TableCell>
              </TableRow>
            ) : reports.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center" sx={{ color: '#aaa', py: 4 }}>
                  No reports found for this period.
                </TableCell>
              </TableRow>
            ) : (
              reports.map((report, index) => (
                <TableRow key={index} sx={{ borderBottom: '1px solid #444' }}>
                  <TableCell sx={{ color: '#fff' }}>{report.sent_at}</TableCell>
                  <TableCell sx={{ color: '#fff' }}>{report.first_name}</TableCell>
                  <TableCell sx={{ color: '#fff' }}>{report.last_name}</TableCell>
                  <TableCell sx={{ color: '#ccc' }}>{report.role}</TableCell>
                  <TableCell sx={{ color: '#fff', maxWidth: '500px', py: 1 }}>
                    {(report.message_text || "").split('|').map((part, i) => (
                      <div key={i} style={{ 
                        display: 'block', 
                        color: i === 0 ? '#fff' : '#bbb', 
                        fontStyle: i > 0 ? 'italic' : 'normal',
                        fontSize: '0.85rem'
                      }}>
                        {part.trim()}
                      </div>
                    ))}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default SmsEmailReportScreen;